import ShareSearch from '@/components/Record/ShareButton/useShareModal/ShareSearch';
import ShareList from '@/components/Record/ShareButton/useShareModal/ShareList';
import React from 'react';
import { RecordFilter } from '@/types/api';
import useAi from '@/components/Record/hooks/useAi';
import { useTalkFlowShareList } from '@/hooks/apiHooks';
import { useFormContext } from 'react-hook-form';

const ShareComponent = () => {
  const { canModify } = useAi();
  const { getValues } = useFormContext<RecordFilter>();
  const { data: shareData, mutate } = useTalkFlowShareList(getValues('docId'));
  return (
    <>
      {canModify && <ShareSearch />}
      {shareData && (
        <ShareList
          shareData={shareData.data}
          mutate={mutate}
          disabled={!canModify}
        />
      )}
    </>
  );
};
export default ShareComponent;
